import { DialogDisclosure, DialogDisclosureProps } from "@ariakit/react";
import * as css from "./style.css";

export function DialogListButton(
  props: DialogDisclosureProps & { borderBlockStart?: "solid" | "none" },
) {
  const { borderBlockStart, ...disclosureProps } = props;
  return (
    <DialogDisclosure
      {...disclosureProps}
      className={css.button({ borderBlockStart })}
    />
  );
}
